<template>
  <div class="print-container">
    <div class="print-header">
      <el-button type="primary" @click="handlePrint">打印</el-button>
    </div>
    <div v-if="nodeinfo.printid==1" class="a4-paper">
      <div class="approval-form">
        <h1 class="form-title">案件审批表</h1>
        <div class="form-header">{{findFormValue('casesn')}} <span style="margin-left: 100px;">号</span> </div>
        
        <div class="form-content">
          <!-- 两栏布局 -->
          <div class="form-row">
            <div class="form-col">
              <span class="label">委托人</span>
              <span class="value">{{findFormValue('client')}}</span>
            </div>
            <div class="form-col">
              <span class="label">联系电话</span>
              <span class="value">{{findFormValue('phone')}}</span>
            </div>
          </div>

          <!-- 单行地址 -->
          <div class="form-row">
            <div class="form-col full">
              <span class="label">地址</span>
              <span class="value">{{findFormValue('address')}}</span>
            </div>
          </div>

          <!-- 两栏布局 -->
          <div class="form-row">
            <div class="form-col">
              <span class="label">对方当事人</span>
              <span class="value">{{findFormValue('opponent')}}</span>
            </div>
            <div class="form-col">
              <span class="label">收案时间</span>
              <span class="value">{{findFormValue('receivetime')}}</span>
            </div>
          </div>

          <!-- 两栏布局 -->
          <div class="form-row">
            <div class="form-col">
              <span class="label">受理法院</span>
              <span class="value">{{findFormValue('court')}}</span>
            </div>
            <div class="form-col">
              <span class="label">第三人</span>
              <span class="value">{{findFormValue('thirdparty')}}</span>
            </div>
          </div>

          <!-- 两栏布局 -->
          <div class="form-row"  style="min-height: 100px;">
            <div class="form-col">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 100px;">案由</span>
              <span class="value">{{findFormValue('casereason')}}</span>
            </div>
            <div class="form-col">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 100px;">案件阶段</span>
              <span class="value">{{findFormValue('casephase')}}</span>
            </div>
          </div>

          <!-- 案件检索情况 -->
          <div class="form-row" style="min-height: 90px;">
            <div class="form-col full">
              <span class="label"style="display: flex; justify-content: center; align-items: center; height: 80px;">案件<br>检索情况</span>
              <span class="value">{{findFormValue('casesearch')}}</span>
              
              <span class="signature">检索人签名：</span>
            </div>
          </div>

          <!-- 四栏布局 -->
          <div class="form-row">
            <div class="form-col half">
              <span class="label">案件标的</span>
              <span class="value">{{findFormValue('caseamount')}}</span>
            </div>
            <div class="form-col half">
              <span class="label">收费金额</span>
              <span class="value">{{findFormValue('feeamount')}}</span>
            </div>
          </div>

          <!-- 四栏布局 -->
          <div class="form-row">
            <div class="form-col half">
              <span class="label">主办律师</span>
              <span class="value">{{findFormValue('mainlawyer')}}</span>
            </div>
            <div class="form-col half">
              <span class="label">协办律师</span>
              <span class="value">{{findFormValue('assistlawyer')}}</span>
            </div>
          </div>

          <!-- 案件简介 -->
          <div class="form-row" style="min-height: 170px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 160px;">案件简介</span>
              <span class="value">{{findFormValue('casesummary')}}</span>
              <div class="signature-line">
                <span>经办律师签名：</span>
                <span class="date"> <span style="margin-left: 70px;">年</span> <span style="margin-left: 25px;">月</span> <span style="margin-left: 25px;">日</span></span>
              </div>
            </div>
          </div>

          <!-- 主任意见 -->
          <div class="form-row" style="min-height: 120px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 110px;">主任意见</span>
              <div class="approval-content">
                <div class="checkbox-group">是否同意立案：<span style="font-size: 28px;"> □</span> 是 <span style="font-size: 28px;"> □</span> 否</div>
                <div class="signature-line">
                  <span>主任签字：</span>
                  <span class="date"> <span style="margin-left: 70px;">年</span> <span style="margin-left: 25px;">月</span> <span style="margin-left: 25px;">日</span></span>
                </div>
              </div>
            </div>
          </div>

          <!-- 备注 -->
          <div class="form-row"  style="min-height: 80px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 80px;">备注</span>
              <span class="value">{{findFormValue('remark')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="nodeinfo.printid==2" class="a4-paper">
      <div class="approval-form">
        <h1 class="form-title">刑事案件收案呈批表</h1>
        <div class="form-header">{{findFormValue('casesn')}} <span style="margin-left: 100px;">号</span> </div>
        
        <div class="form-content">
          <!-- 两栏布局 -->
          <div class="form-row">
            <div class="form-col">
              <span class="label" style="width: 129px;">收案日期</span>
              <span class="value" style="width: 206px;">{{findFormValue('getdate')}}</span>
            </div>
            <div class="form-col">
              <span class="label">涉嫌罪名</span>
              <span class="value">{{findFormValue('charge')}}</span>
            </div>
          </div>
          
          <div class="form-row">
            <div class="" style="width: 30px; height: 80px;text-align: center;padding: 0 10px;">
              <span class="label">委托人</span>
            </div>
            <div style="border-left: 1px solid #000;height: 80px;width: 100%;"> 
              <div style="width: 100%;border-bottom: 1px solid #000;height: 40px;">
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 姓 名 </div>
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('client')}}</div>
                <div style="width: 65px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 性 别 </div>
                <div style="width: 60px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('sex')}}</div>
                <div style="width: 80px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;">身份证号 </div>
                <div style="width: 198px;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('idcard')}}</div>
              </div>
              <div>
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 住 址 </div>
                <div style="width: 525px;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('address')}}</div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="" style="width: 30px; height: 162px;text-align: center;padding: 0 10px;">
              <span class="label">嫌疑人 被告人</span>
            </div>
            <div style="border-left: 1px solid #000;height: 162px; width: 100%;"> 
              <div style="width: 100%;border-bottom: 1px solid #000;height: 40px;">
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 姓 名 </div>
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('bgname')}}</div>
                <div style="width: 65px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 性 别 </div>
                <div style="width: 60px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('bgsex')}}</div>
                <div style="width: 80px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;"> 年 龄 </div>
                <div style="width: 198px;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('bgage')}}</div>
              </div>
              <div style="width: 100%;border-bottom: 1px solid #000;height: 40px;">
                <div style="width: 100px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;">是否羁押</div>
                <div style="width: 50px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('sfjy')}}</div>
                <div style="width: 80px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;">羁押场所</div>
                <div style="width: 180px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('jycs')}}</div>
                <div style="width: 80px;border-right: 1px solid #000;height: 40px;text-align: center;line-height: 40px; float: left;">羁押时间</div>
                <div style="width: 115px;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('jysj')}}</div>
              </div>
              <div style="width: 100%; height: 40px; border-bottom: 1px solid #000;">
                <div style="width: 100px;border-right: 1px solid #000; height: 40px;text-align: center;line-height: 40px; float: left;"> 户 籍 地 </div>
                <div style="width: 475px;height: 40px;text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('bghjd')}}</div>
              </div>
              <div>
                <div style="width: 100px;border-right: 1px solid #000; height: 40px;text-align: center;line-height: 40px; float: left;">与委托人关系</div>
                <div style="width: 480px;height: 40px; text-align: center;line-height: 40px; float: left;color: #555;">{{findFormValue('ywtrgx')}}</div>
              </div>
            </div>
          </div>

           <!-- 案件简介 -->
           <div class="form-row" style="min-height: 120px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height:110px;">简要案情</span>
              <span class="value">{{findFormValue('casesummary')}}</span>
              <div class="signature-line">
                <span>经办律师签名：</span>
                <span class="date"> <span style="margin-left: 70px;">年</span> <span style="margin-left: 25px;">月</span> <span style="margin-left: 25px;">日</span></span>
              </div>
            </div>
          </div>


          
          <!-- 利益冲突 -->
          <div class="form-row" style="min-height: 150px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 100%;">利益冲突涉黑涉恶审查意见</span>
              <div class="approval-content">
                <div class="checkbox-group" style="color: #555;">1、代理案件是否违反江苏常宜律师事务所《执业利益冲突审查制度》第四条、第五条规定：<span style="font-size: 28px;"> □</span> 是 <span style="font-size: 28px;"> □</span> 否</div>
                <div class="checkbox-group" style="color: #555;">2、代理案件是否涉黑涉恶案件：<span style="font-size: 28px;"> □</span> 是 <span style="font-size: 28px;"> □</span> 否</div>
                <div class="signature-line" style="bottom: 24px;">
                  <span>自查人员签名：</span>
                  <span class="date"> <span style="margin-left: 70px;">年</span> <span style="margin-left: 25px;">月</span> <span style="margin-left: 25px;">日</span></span>
                </div>
              </div>
            </div>
          </div>


           <!-- 主任意见 -->
           <div class="form-row" style="min-height: 100px;">
            <div class="form-col full">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 100%;">所意见</span>
              <div class="approval-content">
                <div class="checkbox-group">是否同意立案：<span style="font-size: 28px;"> □</span> 是 <span style="font-size: 28px;"> □</span> 否</div>
                <div class="signature-line" style="bottom: 24px;">
                  <span>主任签字：</span>
                  <span class="date"> <span style="margin-left: 70px;">年</span> <span style="margin-left: 25px;">月</span> <span style="margin-left: 25px;">日</span></span>
                </div>
              </div>
            </div>
          </div>


          <div class="form-row">
            <div class="form-col">
              <span class="label">收费约定</span>
              <span class="value">{{findFormValue('sfyd')}}</span>
            </div>
            <div class="form-col">
              <span class="label">收费情况</span>
              <span class="value">{{findFormValue('sfqk')}}</span>
            </div>
          </div>

         

          <!-- 两栏布局 -->
          <div class="form-row"  style="min-height: 120px;">
            <div class="form-col">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 88%;">结案情况</span>
              <span class="value">  </span>
            </div>
            <div class="form-col">
              <span class="label" style="display: flex; justify-content: center; align-items: center; height: 88%;">备注</span>
              <span class="value">  </span>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNodePrintInfo } from '@/api/case'

export default {
  name: 'PrintForm',
  data() {
    return {
      caseinfo: {},
      nodeinfo:{ printid:-1},
      form:{}
    }
  },
  created() {
    this.fetchNodeInfo()
  },
  methods: {
    async fetchNodeInfo() {
      try {
        const nodeId = this.$route.query.id
        if (!nodeId) {
          this.$message.error('未找到节点ID')
          return
        }
        const response = await getNodePrintInfo({id: nodeId})
        console.log(response)
        if (response) {
          this.caseinfo = response.data.caseinfo
          this.nodeinfo = response.data.nodeinfo
          this.form = response.data.form
        } else {
          this.$message.error(response.msg || '获取节点信息失败')
        }
      } catch (error) {
        console.error('获取节点信息出错:', error)
        this.$message.error('获取节点信息失败')
      }
    },
    handlePrint() {
      window.print()
    },
    findFormValue(keyname) {
        const item = this.form.find(item => item.keyname === keyname)
        return item ? item.value : ''
    }
  }
}
</script>

<style lang="less" scoped>
.print-container {
  padding: 20px;
  
  .print-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    @media print {
      display: none;
    }
  }
  
  .print-content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  }
  
  .loading-tip {
    text-align: center;
    padding: 40px 0;
  }
}

.a4-paper {
  width: 210mm;
  height: 297mm;
  padding: 15mm;
  margin: 0 auto;
  background: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
  
  @media print {
    box-shadow: none;
    padding: 10mm;
  }
}

.approval-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .form-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 8px;
    line-height: 1.6;
  }

  .form-header {
    text-align: right;
    margin-bottom: 15px;
    line-height: 1.6;
  }

  .form-content {
    border: 1px solid #000;
  
    
    .form-row {
      display: flex;
      border-bottom: 1px solid #000;
      min-height: 32px;
      line-height: 1.6;
      
      &:last-child {
        border-bottom: none;
      }
    }

    .form-col {
      flex: 1;
      display: flex;
      border-right: 1px solid #000;
      position: relative;
      padding: 0;
      
      &:last-child {
        border-right: none;
      }

      &.full {
        flex: 1;
      }

      &.half {
        flex: 0.5;
      }

      .label {
        width: 90px;
        text-align: justify;
        text-align-last: justify;
        padding: 8px 10px;
        flex-shrink: 0;
        position: relative;
        border-right: 1px solid #000;
        font-weight: normal;
        
        &:after {
          
          position: absolute;
          right: 3px;
        }
      }

      .value {
        flex: 1;
        padding: 8px 10px;
        word-break: break-all;
        line-height: 1.6;
        color: #555;
      }

      .sub-text {
        position: absolute;
        left: 100px;
        bottom: 8px;
        color: #666;
        font-size: 12px;
      }

      .signature {
        position: absolute;
        right: 80px;
        bottom: 8px;
      }
    }

    .approval-content {
      flex: 1;
      padding: 8px 10px 8px 10px;
      position: relative;
      min-height: 80px;

      .checkbox-group {
        // margin-top: 20px;
        // margin-bottom: 20px;
        line-height: 1.3;
      }
    }

    .signature-line {
      position: absolute;
      bottom: 8px;
      right: 20px;
      display: flex;
      gap: 20px;
      line-height: 1.6;
      
      .date {
        margin-left: 20px;
      }
    }
  }
}

@media print {
  .print-container {
    padding: 0;
  }
  
  .a4-paper {
    box-shadow: none;
    height: 297mm;
    overflow: hidden;
  }
}
</style>